/**
 * AdminInstallBackupsRpcClient - AtomRpc integration for admin install-backups
 * endpoints (`admin/installs/backups.refresh` / `.restore` / `.watch`).
 *
 * Drives the agent Overview tab's backups panel — a live `BackupsView` pushed
 * down the streaming watch, plus the refresh and restore actions. Requires
 * admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallBackupsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallBackupsRpcClient extends AtomRpc.Tag<AdminInstallBackupsRpcClient>()(
  "AdminInstallBackupsRpcClient",
  {
    group: InstallBackupsRpcs,
    protocol: makeRpcClientLayer(InstallBackupsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
